module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/nr-1f7cfffb6cb01e5215ada60e128ea252.svg";